import {
  Box,
  Button,
  HStack,
  Heading,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
  VStack,
  useDisclosure
} from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useReviewContext } from "../state/ReviewContextProvider"
import InboxNavigator from "./InboxNavigator"
import useInboxContext from "./useInboxContext"
import { InboxGroupNode } from "./useInboxItems"

export function InboxPopover({
  onSelect,
  children,
  ...popoverProps
}: {
  onSelect?: (item: InboxGroupNode) => void
} & PopoverProps) {
  const reviewContext = useReviewContext()
  const disclosure = useDisclosure()

  const handleSelectInbox = (item: InboxGroupNode) => {
    reviewContext?.actions?.clearAllSelections?.()
    disclosure.onClose()
    onSelect?.(item)
  }

  return (
    <Popover {...disclosure} closeOnBlur closeOnEsc isLazy {...popoverProps}>
      {(props) => (
        <>
          <PopoverTrigger>
            <Box>
              {typeof children === "function" ? children(props) : children}
            </Box>
          </PopoverTrigger>
          <PopoverContent p={0} w="min(420px, calc(100vw - 20px))">
            <PopoverBody p={0}>
              <InboxNavigator onSelect={handleSelectInbox} />
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  )
}

const InboxSelector = () => {
  const {
    context: { query }
  } = useReviewContext()
  const { inbox, loading } = useInboxContext(query)

  const showLoading = loading === true || !inbox

  return (
    <VStack w="100%" alignItems="center" p={4}>
      <InboxPopover>
        <Button variant="solid" colorScheme="whiteAlpha" size="md">
          <HStack>
            <Pathicon icon="inbox-fill" />
            <Heading
              as="h1"
              size="sm"
              noOfLines={1}
              maxW="200px"
              color="inherit"
              m={0}
            >
              {showLoading ? "Loading... " : inbox.meta.title}
            </Heading>
            <Pathicon icon="chevron-down" />
          </HStack>
        </Button>
      </InboxPopover>
    </VStack>
  )
}

export default InboxSelector
